const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const AIGenerationTypeQueryURL: any = {
    GetAIGenerationTypes: Backofficebff + '/v1/ai-generation-types',
    GetActiveAIGenerationTypes: Backofficebff + '/v1/ai-generation-types/active',
    GetAIGenerationTypeById: Backofficebff + '/v1/ai-generation-types',
    GetAIGenerationTypeByCode: Backofficebff + '/v1/ai-generation-types/by-code',
};

